import { render, staticRenderFns } from "./PanelModal.vue?vue&type=template&id=764a843e&scoped=true"
import script from "./PanelModal.vue?vue&type=script&lang=js"
export * from "./PanelModal.vue?vue&type=script&lang=js"
import style0 from "./PanelModal.vue?vue&type=style&index=0&id=764a843e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764a843e",
  null
  
)

export default component.exports